import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import cx from "classnames";
import { useDebounce } from "../../helpers/useDebounce";

import s from "./WeaveInputWidget.module.scss";

export default function WeaveInputWidget(props) {
	const {
		value = "",
		placeholder = "ex. 0.05",
		disabled,
		icon,
		title = "",
		titleClass = "",
		className = "",
		label = "",
		maxLength = 0,
		onChange = () => {},
		type = "text",
	} = props;
	const [valueText, setValueText] = useState(null);

	const debounceValue = useDebounce(valueText, 1000);
	const threshold = Math.round(valueText?.length >= maxLength * 0.9);

	useEffect(() => {
		//if (value) {
		setValueText(value);
		//}
	}, [value]);

	useEffect(() => {
		let num = debounceValue;
		// Skip initial load
		if (num && num !== value) {
			if (typeof num === "string") {
				//num = debounceValue.replace(/,/g, "");
			}

			onChange(num);
		}

		// eslint-disable-next-line
	}, [debounceValue]);

	return (
		<div className={s.root}>
			{title && <div className={cx(s.title, titleClass)}>{title}</div>}
			{props.children && <>{props.children}</>}

			<div className={s.inputContainer}>
				<Input
					value={valueText || ""}
					onChange={(e) => setValueText(e.target.value)}
					//onFocus={() => setValue(null)}
					type={type}
					placeholder={placeholder}
					disabled={disabled}
					className={cx(s.input, className)}
					{...(maxLength && { maxLength: maxLength })}
				/>

				{icon && <p className={s.icon}>{icon}</p>}
			</div>

			{label && <p className={s.label}>{label}</p>}
			{maxLength > 0 && (
				<span className={cx(s.charsCount, threshold ? s.warning : "")}>
					{valueText?.length || "0"}/{maxLength}
				</span>
			)}
		</div>
	);
}
